import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0A0F20] flex flex-col items-center justify-center text-center px-4">
      {/* Heading */}
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-3xl sm:text-5xl font-extrabold text-white mb-4 leading-snug"
      >
        Welcome to <br />
        <span className="text-blue-600 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
          Smart <br className="sm:hidden" />
          Learning & <br className="sm:hidden" />
          Programming <br className="sm:hidden" />
          Resource
        </span>
      </motion.h1>

      {/* Subheading */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-lg sm:text-xl text-gray-400 mb-8 max-w-xl"
      >
        Start your journey to mastering <strong>Python</strong> and tech skills with our curated roadmaps and resources.
      </motion.p>

      {/* Buttons */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="flex flex-col sm:flex-row gap-4"
      >
        <Link to="/resources">
          <button className="bg-blue-600 text-white px-6 py-3 rounded-full font-medium hover:bg-blue-700 hover:scale-105 transition-all duration-300">
            Get Started
          </button>
        </Link>
        <Link to="/community">
          <button className="border-2 border-gray-600 text-white px-6 py-3 rounded-full font-medium hover:bg-gray-800 hover:text-white hover:scale-105 transition-all duration-300">
            Join Our Community
          </button>
        </Link>
      </motion.div>
    </div>
  );
};

export default HomePage;